import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';

class VoyageToast extends LitElement {
  @property({ type: Boolean }) visible = false;
  @property({ type: String }) message = '';
  @property({ type: String }) type = ''; // 'success' or 'error'

  static styles = css`
    .toast {
      visibility: hidden;
      display: flex;
      min-width: 250px;
      text-align: center;
      border-radius: 5px;
      padding: 12px;
      position: fixed;
      z-index: 1;
      bottom: 30px;
      font-size: 15px;
      opacity: 0;
      align-items: center;
      transition: opacity 0.5s, visibility 0.5s ease-in-out;
      font-family: MaerskText;
      left: 50%;
      transform: translateX(-50%);
    }

    .toast.success{
       background-color: rgba(220, 246, 217, 1);
    }

    .toast.error{
        background-color: #f5c4c4;
    }

    .toast.show {
      visibility: visible;
      opacity: 1;
    }

    message-container {
      flex-grow: 1;
      text-align: left;
      margin-left: 8px;
      margin-right: 8px;
    }

    .close-icon {
      cursor: pointer;
      margin-left: 55px;
      padding-bottom: 7px;
      width: 10px;
      height: 10px;
    }

    .icon {
      margin-right: 10px;
      width: 18px;
      height: 18px;
    }

    .icon.success{
      color: rgba(50, 133, 41, 1);
    }

    .icon.error{
      color: var(--voyage-error-red);
      padding-bottom: 5px;
    }
  `;

  render() {
    return html`
      <div class="toast ${this.visible ? 'show' : ''} ${this.type}">
        <span class="icon ${this.type}">${this.type === 'error' ? SvgIcons.lightTimesCircle : SvgIcons.lightCheckCircle}</span> 
        <div class="message-container">${this.message}</div>
        <span class="close-icon" @click=${this._closeToast}>${SvgIcons.lightTimes}</span>
      </div>
    `;
  }

  show(message: string, type: string) {
    this.message = message;
    this.visible = true;
    this.type = type;

    // Hide the toast after 3 seconds
    setTimeout(() => {
      this.visible = false;
    }, 3000);
  }

  private _closeToast() {
    this.visible = false;
  }
}

customElements.define('voy-toast', VoyageToast);